<template lang="pug">
.new-customer
  CustomerFields(:customer="newCustomer")
  BriqCheckbox(label="Company?" v-model="isCompany" data-test-id="customer-company")
  CompanyFields(v-if="isCompany" :customer="newCustomer")
</template>

<script>
import CustomerFields from './CustomerFields.vue'
import CompanyFields from './CompanyFields.vue'

export default {
  name: 'NewCustomer',
  components: { CustomerFields, CompanyFields },
  props: {
    lastSearchQuery: String,
  },
  data() {
    return {
      isCompany: false,
      newCustomer: {
        Firstname: '',
        Lastname: '',
        Email: '',
        Mobilenumber: '',
        CompanyName: '',
        CompanyAddress: '',
        CompanyZipcode: '',
        CompanyCity: '',
        CompanyCountryCode: '',
        CompanyEmail: '',
        CompanyPhonenumber: '',
        CompanyTaxNumber: '',
        CompanyCocNumber: '',
        CustomReference: '',
      },
    }
  },
  mounted() {
    // todo: refactor using composition API
    this.$bus.$on('getNewCustomer', callback => callback(this.newCustomer))
    this.newCustomer.Email = this.lastSearchQuery
  },
}
</script>

<style lang="stylus">
.new-customer .briq-form-element
  margin-bottom 24px
</style>
